<template>
  <div>
    <e-c-facet-header
      v-if="header"
      :title="header"
      :tooltip="toolTipTitle"
    />
    <div class="ecl-select__container ecl-select__container--m w-100">
      <select class="ecl-select" id="select-default" required v-model="selected">
        <option
          v-for="(item, index) in items"
          :value="item"
          :key="getTitle(item)+index">
          {{ getTitle(item) }}
        </option>
      </select>
      <div class="ecl-select__icon">
        <svg class="ecl-icon ecl-icon--s ecl-icon--rotate-180 ecl-select__icon-shape" focusable="false" aria-hidden="true">
          <use xlink:href="../assets/img/ecl/icons.svg#corner-arrow"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import ECFacetHeader from "@/components/ECFacetHeader";
import { helpers } from '@piveau/piveau-hub-ui-modules';
const { getFacetTranslation } = helpers;
export default {
  name: "ECSingleSelectFacet",
  components: {ECFacetHeader},
  props: {
    header: {
      type: String,
      default: '',
    },
    fieldId: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    toolTipTitle: {
      type: String,
      default: '',
    },
    showFilter: String,
    facetIsSelected: Function,
    facetClicked: Function
  },
  data() {
    return {
      selected: this.items.find(item => {
        return this.facetIsSelected(this.fieldId, item)
      })
    }
  },
  methods: {
    getFacetTranslation,
    getTitle(item) {
      const fallbackTitle = this.resolveLocalizedTitle(item?.title);
      return this.i18n.global.te(`message.datasetFacets.facets.datascopeField.${item.id}`) ?
        this.i18n.global.t(`message.datasetFacets.facets.datascopeField.${item.id}`)
        : this.getFacetTranslationWrapper(this.fieldId, item.id, this.$route.query.locale, fallbackTitle || item.title);
    },
    resolveLocalizedTitle(title) {
      if (!title || typeof title !== 'object') return title;
      const titleMap = title.title && typeof title.title === 'object' ? title.title : title;
      const locale = this.$route.query.locale || this.$i18n.locale || 'en';
      return titleMap[locale]
        || titleMap.en
        || Object.values(titleMap).find(value => typeof value === 'string')
        || '';
    },
    getFacetTranslationWrapper(fieldId, facetId, userLocale, fallback) {
      if (fieldId === "country" && String(facetId).toLowerCase() === "eu") {
        return "Europe";
      }
      return fieldId === 'scoring'
        ? this.i18n.global.t(`message.datasetFacets.facets.scoring.${facetId}`)
        : this.getFacetTranslation(fieldId, facetId, userLocale, fallback);
    },
  },
  watch: {
    items(newItems) {
      this.selected = newItems.find(item => this.facetIsSelected(this.fieldId, item));
    },
    selected(next, previous) {
      if (next.id !== previous.id) this.facetClicked(this.fieldId, this.selected);
    }
  }
}
</script>

<style scoped>

</style>
